<template>
  <div class="register-main__content">
    <div style="display: flex; width: 100%">
      <img
        class="logo-image"
        style="display: flex; width: 6rem; height: 2rem; margin-top: 1.5rem"
        src="/assets/landing/clients/cf_logo_color.png"
        alt=""
        v-if="$theme.theme.name == 'iccs'"
      />
      <img
        class="logo-image"
        style="display: flex; height: 3rem; margin: 1rem"
        src="/assets/landing/research-ai-logo.svg"
        alt=""
        v-else
      />
    </div>

    <h1 class="register-main__title">
      <VisibleText>Create an account</VisibleText>
    </h1>
    <Register ref="register" class="register-main__form" :inviteId="c" @registered="registered">
      <template #email="{ email: scopedEmail, errors, emailBlurCheck, emailInputCheck, update }">
        <label for="email" class="auth-form__label">
          <VisibleText>Business / organization email</VisibleText>
          <input
            id="email"
            ref="email"
            :value="scopedEmail"
            @input="
              (e) => {
                update('email', e.target.value);
                emailInputCheck(e);
              }
            "
            type="text"
            class="auth-form__input"
            required
            aria-required="true"
            :aria-invalid="!!errors.length"
            @blur="emailBlurCheck"
          />
        </label>
      </template>

      <template #password="{ password, errors, passwordBlurCheck, update, email }">
        <label for="password" class="auth-form__label" v-if="email && !errors.email.length">
          <VisibleText>Password</VisibleText>
          <input
            id="password"
            :value="password"
            @input="update('password', $event.target.value)"
            type="password"
            class="auth-form__input"
            required
            aria-required="true"
            :aria-invalid="!!errors.password.length"
            aria-describedby="password-desc"
            @blur="passwordBlurCheck"
          />
          <span
            id="password-desc"
            v-if="!errors.password.includes('Passwords should be at least 10 characters long')"
            :class="{ valid: password.length >= 10 }"
          >
            <VisibleText>Passwords should be at least 10 characters long </VisibleText>
          </span>
        </label>
      </template>

      <template #passwordConf="{ passwordConf, errors, passwordConfBlurCheck, update, email }">
        <label for="password-conf" class="auth-form__label" v-if="email && !errors.email.length">
          <VisibleText>Confirm Password</VisibleText>
          <input
            id="password-conf"
            ref="password-conf"
            :value="passwordConf"
            @input="update('passwordConf', $event.target.value)"
            type="password"
            class="auth-form__input"
            required
            aria-required="true"
            :aria-invalid="!!errors.passwordConf.length"
            @blur="passwordConfBlurCheck"
          />
        </label>
      </template>
    </Register>
    <p>
      <VisibleText>Already have an account? Use our </VisibleText>
      <router-link to="/login">
        <VisibleText>login page</VisibleText>
      </router-link>
    </p>
    <p>
      <VisibleText>Have an invite or demo code? </VisibleText>
      <router-link to="/register/demo">
        <VisibleText>Enter it Here</VisibleText>
      </router-link>
    </p>
    <div style="display: flex; flex-direction: row">
      <VisibleText>By using ResearchAI, you agree to the following: </VisibleText>
      <div style="margin: 0 1rem">
        <router-link to="/library/terms">
          <VisibleText>Terms</VisibleText>
        </router-link>
      </div>
      <div style="margin-right: 1rem">|</div>
      <div>
        <router-link to="/library/privacy-policy">
          <VisibleText>Privacy</VisibleText>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { Register } from '@/pigeonline/wrapper';

export default {
  name: 'register',
  components: { Register },
  data() {
    return {
      inputed_email: null,
      c: null,
      role: null,
    };
  },
  async created() {
    this.inputed_email = this.$route.query.email;
    this.c = this.$route.query.c;

    // check if c is valid else redirect to login
    if (this.c && !this.c.match(/^[0-9a-fA-F]{24}$/)) {
      this.$router.push({
        name: 'login',
      });
    }
  },
  mounted() {
    if (this.inputed_email) {
      this.$refs.register.update('email', this.inputed_email);
      this.$refs.email.disabled = true;
      this.$refs.email.classList.add('uneditable');
    }
  },
  methods: {
    async registered(registered) {
      // redirect to register verification page if is_email_verified = false
      if (!registered.is_email_verified) {
        this.$router.push({
          path: 'register/verify',
          query: {
            email: registered.email,
            status: 'account_created',
          },
        });
      } else {
        // login user automatically
        await this.$pigeonline.login(
          this.$refs.register.$data['email'],
          this.$refs.register.$data['password'],
        );
        this.$router.push(
          {
            path: this.$route.query.redirect || 'account/profile',
          },
          () => this.$router.go(0),
        );
      }
    },
  },
};
</script>
